module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-image-1-sp-51be23395f6d4950f058bec82e3b2639.png";